/**
 * useDynamicBreadcrumb.js
 * Custom hook for setting dynamic breadcrumb data
 */

import { useEffect } from 'react';
import { addBreadcrumbConfig } from './breadcrumbHelper';

/**
 * Hook to set dynamic breadcrumb configuration
 * @param {string} pathname - The current pathname
 * @param {Array} breadcrumbs - Array of breadcrumb items
 * 
 * Example usage:
 * useDynamicBreadcrumb(`/users/${id}/edit`, [
 *   { label: 'Atleti', path: '/users', icon: 'fas fa-users' },
 *   { label: `${user.firstName} ${user.lastName}`, path: null, icon: 'fas fa-user' }
 * ]);
 */
export const useDynamicBreadcrumb = (pathname, breadcrumbs) => {
  useEffect(() => {
    if (pathname && breadcrumbs && breadcrumbs.length > 0) {
      addBreadcrumbConfig(pathname, breadcrumbs);
    }
  }, [pathname, breadcrumbs]);
};

export default useDynamicBreadcrumb;
